/* ===== MixMart — scripts propios ===== */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Animacion de entrada al hacer scroll */
  function initReveals() {
    var els = document.querySelectorAll('.mm-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mm-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var retraso = parseInt(e.target.getAttribute('data-mm-retraso') || '0', 10);
        setTimeout(function () { e.target.classList.add('mm-visible'); }, retraso);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* Cifras que cuentan hacia arriba */
  function initCifras() {
    var els = document.querySelectorAll('[data-mm-contar]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        var destino = parseFloat(el.getAttribute('data-mm-contar'));
        if (isNaN(destino)) return;
        var sufijo = el.getAttribute('data-mm-sufijo') || '';
        var ini = performance.now();
        var dur = 1500;
        function paso(ahora) {
          var p = Math.min((ahora - ini) / dur, 1);
          var suave = 1 - Math.pow(1 - p, 3);
          var v = destino * suave;
          el.textContent = (destino % 1 === 0 ? Math.round(v) : v.toFixed(1)) + sufijo;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* Cinta y resenas: duplicar contenido para bucle infinito sin salto */
  function initPistas() {
    document.querySelectorAll('[data-mm-pista]').forEach(function (pista) {
      if (pista.getAttribute('data-mm-clonada') === 'si') return;
      var original = pista.innerHTML;
      pista.innerHTML = original + original;
      pista.setAttribute('data-mm-clonada', 'si');
    });
  }

  /* FAQ: solo un desplegable abierto a la vez */
  function initFaq() {
    var items = document.querySelectorAll('.mm-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (otro) {
          if (otro !== item && otro.open) otro.open = false;
        });
      });
    });
  }

  function init() {
    initPistas();
    initReveals();
    initCifras();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El editor de Shopify recarga secciones sueltas */
  document.addEventListener('shopify:section:load', init);
})();
